import axios from 'axios'
import { notify } from '@kyvg/vue3-notification';

export const defaultColors = ['#77C490', '#FA6364', '#3DA89C', '#60ACD8', '#379740', '#8B75D7', '#C00318', '#FEBC3B', '#22E3A2', '#259FFB']

export const colors = ['#C00318', '#F4343C', '#FA6364', '#F98A2C', '#FDB571', '#FECA42', '#F4B620', '#9ACB3D', '#87B337', '#4CBB4C', '#379740']

export const findById = (resources, id) => {
    if (!resources) return null
    return resources.find(r => r.id === id)
}

export const removeById = (state, id) => {
    const i = state.items.findIndex(item => item.id === id)
    if (i > -1) {
        state.items.splice(i, 1)
    } else {
        console.warn(`removeById: item not found id:${i}`)
    }
}

/**
 * Extrai os ids de um array de tags, aceitando tanto o shape antigo (array de ids)
 * quanto o novo (array de objetos TagsResource).
 * @param {Array} tags
 * @returns {Array}
 */
export const getTagIds = (tags = []) => {
    if (!Array.isArray(tags)) return []
    return tags.map((tag) => (typeof tag === 'object' && tag !== null ? tag.id : tag))
}

export const upsert = (state, resource) => {

    if (Array.isArray(resource)) {
        state.items = resource
    } else {
        const index = state.items.findIndex(p => p.id === resource.id)
        if (resource.id && index !== -1) {
            state.items[index] = resource
        } else {
            state.items.push(resource)
        }
    }

}

export const insert = async (state, url, payload, data = 'data') => {

    return axios.post(url, payload)
        .then(response => {
            if (data) {
                upsert(state, response.data[data])
            } else {
                upsert(state, response.data)
            }
            return response.data
        })
        .catch(e => {
            console.error(e?.response?.data)

            if (state?.fullError) {
                return Promise.reject(e)
            }

            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}
export const insertFormData = async (state, url, payload) => {
    return axios.post(url, payload, { header: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            upsert(state, response.data.data)
            return response.data
        })
        .catch(e => {
            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}


export const update = async (state, url, payload, method = 'put', data = 'data') => {
    return axios[method](url, payload)
        .then(response => {
            if (data) {
                upsert(state, response.data[data])
            } else {
                upsert(state, response.data)
            }
            return response.data
        }).catch(e => {
            console.error(e)
            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}
export const remove = async (state, url, id) => {
    return axios.delete(url + '/' + id)
        .then(() => {
            removeById(state, id)
            return true
        }).catch(e => {
            const errorData = e?.response?.data
            const fallback = {
                error: errorData?.error || 'ServerError',
                message: errorData?.message || 'Não foi possível remover o registro.'
            }
            return Promise.reject(errorData || fallback)
        })
}
export const list = async (state, url, data = 'data') => {

    return axios.get(url)
        .then(response => {
            if (data) {
                upsert(state, response.data[data])
            } else {
                upsert(state, response.data)
            }
            return response.data
        }).catch(e => {
            if (state?.fullError) {
                return Promise.reject(e)
            }
            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}

export async function axiosget(URL) {

    return axios.get(URL)
        .then(response => {
            return response.data
        }).catch(e => {
            // Verifica se tem message ou error na resposta
            const errorMessage = e?.response?.data?.message || e?.response?.data?.error;
            // Se não tiver nenhum, rejeita com o erro completo para manter compatibilidade
            if (!errorMessage) {
                return Promise.reject(e)
            }
            return Promise.reject(errorMessage)
        })
}

export async function axiospost(URL, payload) {
    return axios.post(URL, payload)
        .then(response => response.data)
        .catch(e => {
            const errorMessage = e?.response?.data?.message || e?.response?.data?.error;
            if (!errorMessage) {
                return Promise.reject(e)
            }
            return Promise.reject(errorMessage)
        })
}

/**
 * Converte um Blob para texto
 * @param {Blob} blob - O blob para converter
 * @returns {Promise<string>} - O texto resultante
 */
export function blobToText(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Erro ao ler o Blob'));
        reader.readAsText(blob);
    });
}

export async function axiosDown({ filter, name_file = 'relatorio-chatmix', url = 'v1/reports/attendance/exportExcell' }) {
    const URL = url
    const options = { responseType: 'blob' }
    return axios.post(URL, filter, options)
        .then(response => {
            // verifico o status do retorno se é 200
            if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', name_file);
                document.body.appendChild(fileLink);
                fileLink.click();
                return true
            }
            return blobToText(response.data)
                .then(textContent => {
                    // Tentar converter para JSON
                    let jsonData;
                    try {
                        jsonData = JSON.parse(textContent);
                        notify({
                            type: 'infor',
                            title: 'Relatório processando em segundo plano!',
                            text: jsonData.message,
                            duration: 6000,
                            width: 500
                        })
                    } catch (e) {
                        console.error('Erro ao fazer parse do JSON:', e);
                        jsonData = { message: textContent };
                        notify({
                            type: 'error',
                            title: 'Opps!',
                            text: 'Erro ao fazer parse do JSON',
                        })
                    }
                    return true
                })

        }).catch(e => {
            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}
export async function axiosDownload({ title, rows, name_file = 'relatorio-chatmix', url = 'v1/reports/attendance/exportExcell' }) {
    const URL = url
    const options = { responseType: 'blob' }
    return axios.post(URL, { title, rows }, options)
        .then(response => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', name_file);
            document.body.appendChild(fileLink);
            fileLink.click();
            return true
        }).catch(e => {
            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}

export const getItem = async (state, url, data = 'data') => {
    return axios.get(url)
        .then(response => {
            state.item = response.data[data]
            return response.data
        }).catch(e => {
            const errorCode = e?.response?.data?.error || 'ServerError';
            return Promise.reject(errorCode)
        })
}

export const arrayRandom = (array) => {
    const randomIndex = Math.floor(Math.random() * array.length)
    return array[randomIndex]
}

export const getEmoji = (item = null) => {
    // finish
    const emoji = [
        { name: 'global', hex: '&#x1F310;', icon: '🌐', type: 'global' },
        { name: 'super_global', hex: '&#x1F30D;', icon: '🌍', type: 'super_global' },
        { name: 'message_start', hex: '&#x25B6;', icon: '▶️', type: 'start' }, //;&#xFE0F;
        { name: 'message', hex: '&#x1F4AC;', icon: '💬', type: 'message' },
        { name: 'transfer', hex: '&#x1F503;', icon: '🔃', type: 'transfer' },
        { name: 'back', hex: '&#x1F519;', icon: '🔙', type: 'back' },
        { name: 'client_identify', hex: '&#x1F600;', icon: '😃', type: 'isp_consult' },
        { name: 'service_available', hex: '&#x1F4CD;', icon: '📍', type: 'isp_available' },
        { name: 'duplicate_ticket', hex: '&#x1F4B8;', icon: '💵', type: 'isp_duplicate' },
        { name: 'promise_of_payment', hex: '&#x1F64F;', icon: '🙏🏻', type: 'isp_promise' },
        { name: 'call_opening', hex: '&#x1F198;', icon: '🆘', type: 'isp_occurrence' },
        { name: 'add_crm', hex: '&#x1F4DD;', icon: '📝', type: 'isp_add_crm' },
        { name: 'finish', hex: '&#x1F590;', icon: '🖐', type: 'finish' },
        { name: 'transfer_automation', hex: '&#x1F501;', icon: '🔁', type: 'transfer_automation' },
        { name: 'remove_auto_identifier', hex: '&#1F6AB;', icon: '🚫', type: 'remove_auto_identifier' },
        { name: 'tag', hex: '&#x1F3F7;', icon: '🏷️', type: 'tag' },
        { name: 'schedule', hex: '&#x23F0;', icon: '⏰', type: 'schedule' },
        { name: 'appointment', hex: '&#x1F4C5;', icon: '📅', type: 'appointment' },
    ]

    if (item) {
        const find = emoji.find(e => e.type === item)
        if (find) return find
        return null
    }

    return emoji
}

export const substringForText = (text, array = [], compare = 'name') => {
    array.forEach((item) => {
        if (text.indexOf(item[compare]) >= 0) {
            text = text.split(item[compare])[1]
        }
    })
    return text.trim()
}

export const isKeyExists = (obj, key) => {
    if (!obj && !key) {
        return null
    }
    if (!Object.prototype.hasOwnProperty.call(obj, key)) return false

    return obj[key] !== false
}

export const assignEntries = (defaultValues, values) => Object.keys(defaultValues).reduce((acc, key) => ({
    ...acc,
    [key]: values[key] || defaultValues[key],
}), {});

export function mergeUnique(arr1, arr2) {
    return arr1.concat(arr2.filter(function (item) {
        return arr1.indexOf(item) === -1;
    }));
}

export function formatMoney(valor) {
    valor = valor + '';
    valor = parseInt(valor.replace(/[\D]+/g, ''));
    valor = valor + '';
    valor = valor.replace(/([0-9]{2})$/g, ',$1');
    if (valor.length > 6) {
        valor = valor.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
    }
    return valor;
}

export function routeResolve(url, blank = '_blank') {
    const BASE = (window.origin === 'http://localhost:3000') ? 'https://www.chatmix.com.br' : window.origin
    window.open(BASE + url, blank);
}

// Retorna o id do atendimento em que a conversa continuou (more.continued_in_webchat)
export function getContinuedInWebchat(more) {
    if (typeof more === 'string') {
        try {
            more = JSON.parse(more)
        } catch (e) {
            return null
        }
    }
    return more?.continued_in_webchat ?? null
}

export function formatBytes(bytes, decimals = 2) {
    if (bytes == 0) {
        return '0 Byte';
    }
    var k = 1024; //Or 1 kilo = 1000
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}
export function formatNumber(item) {
    return item.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.')
}

export function sum(data, field = 'qtd') {
    return data.reduce((total, item) => parseInt(total) + (parseInt(item[field])), 0)
}
export function calcPercentage(total, item = 0) {
    return ((item * 100) / total).toFixed(2)
}
export function joinfirstNameLastName(first, last) {
    const name = first + ' ' + last
    return name.length > 20 ? first : name
}
export function removeAccent(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export function normalizeText(value) {
    return removeAccent(String(value ?? '').toLowerCase().trim())
}

/**
 * @param {string|number} text
 * @param {boolean} blockNotify
 */
export const copyToClipboard = (text, blockNotify = false) => {

    const el = document.createElement('textarea')
    el.value = text
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)

    if (blockNotify) return
    notify({
        title: 'Conteúdo copiado!',
        type: 'success',
        duration: 500,
    })
}

export function arrayMatch(arr1 = [], arr2 = []) {
    let arr = [];  // Array to contain match elements
    // for array1
    for (let i = 0; i < arr1.length; ++i) {
        const result = arr2.find(el => el.toString().toLowerCase() === arr1[i].toString().toLowerCase())
        if (result) arr.push(result)
    }
    return arr;  // Return the arr elements
}

export function gerarCodigoAleatorio(tamanho) {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    let codigo = ''

    for (let i = 0; i < tamanho; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length)
        codigo += caracteres.charAt(indiceAleatorio)
    }

    return codigo
}

export function checkChannelTypeWhatsApp(value) {
    const serversType = ['go', 'goMD', 'dialog360', 'dialog360_cloud', 'whatsapp_meta', 'otima']
    return serversType.includes(value)
}

// funcao que converte uma string
// const search = "?datestart=2023-11-16 00:00:00&dateend=2023-11-22 23:59:59&users=201215,201309&tags=233,166"
// para a assim:  const filter = { datestart:'2023-11-16 00:00:00', dateend : '2023-11-22 23:59:59', users:'201215,201309', tags:'233,166'}
export function parseQueryString(search) {
    // Remover o ponto de interrogação inicial, se existir
    const queryString = search.startsWith('?') ? search.slice(1) : search
    // Dividir a string pelos caracteres "&" para obter pares chave-valor
    const keyValuePairs = queryString.split('&')
    // Inicializar o objeto de filtro
    const filter = {}
    // Iterar sobre os pares chave-valor e adicionar ao objeto de filtro
    keyValuePairs.forEach((pair) => {
        const [key, value] = pair.split('=')
        filter[key] = value
    })
    // Retornar o objeto de filtro resultante
    return filter
}

export function getUrlBaseV2() {
    // Verifica se está em desenvolvimento e se existe a URL de desenvolvimento configurada
    const isDevelopment = import.meta.env.VITE_APP_ENV === 'development' || import.meta.env.DEV
    const devApiUrl = import.meta.env.VITE_API_V2_DEV_URL

    if (isDevelopment && devApiUrl) {
        return devApiUrl
    }

    const path = '/api-v2'
    let url = window.origin + path
    // caso a url possua o localhost, substitui por vmix.chatmix
    if (url.includes('localhost')) {
        return import.meta.env.VITE_CHAT_DOMAIN + path
    }
    return url
}

export function getUrlApiV1() {

    const path = '/api_v2/api/v1'
    let url = window.origin + path
    // caso a url possua o localhost, substitui por vmix.chatmix
    if (url.includes('localhost')) {
        return import.meta.env.VITE_CHAT_DOMAIN + path ?? window.origin + path
    }
    return url


}

export function getBaseUrl() {
    if (window.origin.includes('localhost')) {
        return import.meta.env.VITE_CHAT_DOMAIN
    }
    return window.origin
}
